import type { ReactNode } from 'react';
import { Col, Icon, Modal, Row, Tag, Text } from 'ui';
import { useEventRsvpLabels } from '../../hooks';

type P = {
  extra?: ReactNode;
  goingInviteesCount: number;
  notGoingInviteesCount: number;
  pendingInviteesCount: number;
};

const EventInviteesFooter = ({ extra, goingInviteesCount, notGoingInviteesCount, pendingInviteesCount }: P) => {
  const { getCountLabel } = useEventRsvpLabels();

  return (
    <Modal.ScrollableContent.Footer>
      <Row align="middle" justify="space-between">
        <Col>
          <Tag color="success" icon={<Icon icon="check-circle-fill" />} noBackground size="medium">
            <Text type="title" weight="medium">
              {getCountLabel({ count: goingInviteesCount, rsvp: 'going' })}
            </Text>
          </Tag>
          <Tag icon={<Icon icon="time-fill" />} noBackground size="medium">
            <Text type="title" weight="medium">
              {getCountLabel({ count: pendingInviteesCount, rsvp: 'pending' })}
            </Text>
          </Tag>
          <Tag color="error" icon={<Icon icon="close-circle-fill" />} noBackground size="medium">
            <Text type="title" weight="medium">
              {getCountLabel({ count: notGoingInviteesCount, rsvp: 'not_going' })}
            </Text>
          </Tag>
        </Col>
        {extra ? <Col>{extra}</Col> : undefined}
      </Row>
    </Modal.ScrollableContent.Footer>
  );
};

export default EventInviteesFooter;
